// Business mappers and builders
import {
  buildGA4Products, buildGA4Promotions, buildProductTypeList,
} from './productsBuilder';

/**
 * GA4 Builder of ecommerce payload to send in the final datalayer object
 * @param {string} eventName Event name to recognize events vs ecommerce tracks
 * @param {object} originalPayload Payload sent from the app who calls track
 * @return {object} Ecommerce object to final dataLayer
 */
export const buildGA4EcommercePayload = (eventName, originalPayload) => { // NOSONAR
  let ga4Items = [];

  if (originalPayload.products) {
    ga4Items = originalPayload.products.map(buildGA4Products);
  } else if (originalPayload.impressions) {
    ga4Items = originalPayload.impressions.map(buildGA4Products);
  } else if (originalPayload.promotions) {
    ga4Items = originalPayload.promotions.map(buildGA4Promotions);
  } else if (originalPayload.promotion) {
    if (!originalPayload.promotions) {
      ga4Items = [originalPayload.promotion].map(buildGA4Promotions);
    }
  }

  const finalPayload = {
    /* transactional data */
    ...(originalPayload.actionField ? {
      ...(originalPayload.actionField.id ? {
        transaction_id: originalPayload.actionField.id,
      } : {}),
      ...(originalPayload.actionField.revenue ? {
        value: originalPayload.actionField.revenue,
      } : {}),
      ...(originalPayload.actionField.tax ? {
        tax: originalPayload.actionField.tax,
      } : {}),
      ...(originalPayload.actionField.shipping !== undefined ? {
        shipping: originalPayload.actionField.shipping,
      } : {}),
      ...(originalPayload.actionField.shippingTier ? {
        shipping_tier: originalPayload.actionField.shippingTier,
      } : {}),
      ...(originalPayload.actionField.coupon ? {
        coupon: originalPayload.actionField.coupon,
      } : {}),
    } : {}),
    /* product data */
    ...(ga4Items.length > 0 ? {
      items: ga4Items,
    } : {}),
    /* event specific data */
    ...(originalPayload.currencyCode ? {
      currency: originalPayload.currencyCode,
    } : {}),
    ...(originalPayload.paymentType ? {
      payment_type: originalPayload.paymentType,
    } : {}),
    ...(originalPayload.paymentInstallments ? {
      payment_installments: originalPayload.paymentInstallments,
    } : {}),
  };

  return {
    ...(originalPayload.original_country ? {
      original_country: originalPayload.original_country,
    } : {}),
    ...(originalPayload.order ? {
      order: originalPayload.order,
    } : {}),
    ...(originalPayload.currencyCode ? {
      currency: originalPayload.currencyCode,
    } : {}),
    ...(originalPayload.payment_type ? {
      payment_type: originalPayload.payment_type,
    } : {}),
    ...(originalPayload.paymentInstallments ? {
      payment_installments: originalPayload.paymentInstallments,
    } : {}),
    ...(originalPayload.origin_country ? {
      origin_country: originalPayload.origin_country,
    } : {}),
    ...(originalPayload.origin_airport ? {
      origin_airport: originalPayload.origin_airport,
    } : {}),
    ...(originalPayload.origin_city ? {
      origin_city: originalPayload.origin_city,
    } : {}),
    ...(originalPayload.destination_country ? {
      destination_country: originalPayload.destination_country,
    } : {}),
    ...(originalPayload.destination_airport ? {
      destination_airport: originalPayload.destination_airport,
    } : {}),
    ...(originalPayload.destination_city ? {
      destination_city: originalPayload.destination_city,
    } : {}),
    ...(originalPayload.departure_date ? {
      departure_date: originalPayload.departure_date,
    } : {}),
    ...(originalPayload.arrival_date ? {
      arrival_date: originalPayload.arrival_date,
    } : {}),
    ...(originalPayload.travel_type ? {
      travel_type: originalPayload.travel_type,
    } : {}),
    ...(originalPayload.business_unit ? {
      business_unit: originalPayload.business_unit,
    } : {}),
    ...(originalPayload.adults ? {
      adults: originalPayload.adults,
    } : {}),
    ...(originalPayload.children ? {
      children: originalPayload.children,
    } : {}),
    ...(originalPayload.infants ? {
      infants: originalPayload.infants,
    } : {}),
    ...(originalPayload.products ? {
      product_list: buildProductTypeList(originalPayload.products),
    } : {}),
    ...(originalPayload.impressions ? {
      product_list: buildProductTypeList(originalPayload.impressions),
    } : {}),
    ecommerce: {
      ...finalPayload,
    },

  };
};
